import Link from "next/link";
import Image from "next/image";

/**
 * Brand lockup — Peepal artwork (tree mark + "THE PEEPAL" wordmark) with
 * the tagline set as live text on two lines, stacked below the mark the
 * same way the original artwork had it.
 *
 * The tagline was cropped out of the artwork because it was baked in at
 * roughly 4px and unreadable at any nav size.
 *
 * Sizes step down on small screens so the stacked lockup does not force an
 * oversized header on mobile.
 *
 * The artwork is dark-on-transparent, so it sits on a white plate to stay
 * legible against the dark greens.
 */
export default function BrandLockup({
  className = "",
  priority = false,
}: {
  className?: string;
  priority?: boolean;
}) {
  return (
    <Link
      href="/"
      className={`group inline-flex items-center ${className}`}
      aria-label="The Peepal — Rooted in Wisdom. Growing with Purpose"
    >
      <div className="flex flex-col items-center rounded-3xl bg-white px-4 py-2 transition-transform duration-200 group-hover:scale-[1.02]">
        <Image
          src="/logo-mark.webp"
          alt="The Peepal"
          width={102}
          height={86}
          priority={priority}
          quality={100}
          className="h-[58px] w-auto object-contain lg:h-[98px]"
        />
        <span className="mt-1.5 block text-center text-[8px] font-semibold uppercase leading-[1.4] tracking-[.06em] text-[#4a7c35]">
          Rooted in Wisdom.
          <br />
          Growing with Purpose
        </span>
      </div>
    </Link>
  );
}
